module.exports = __webpack_public_path__ + "static/img/mode.3fbea8fe.png";